<template>
  <div class="container">
       <a-tabs default-active-key="1" @change="callback">
      <a-tab-pane key="1" tab="web端版本更新">
        Content of Tab Pane 1
      </a-tab-pane>
      <a-tab-pane key="2" tab="移动端版本更新">
        Content of Tab Pane 2
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>

export default {

}
</script>

<style>

</style>